import { defineMessages } from '@atlassian/jira-intl';

export const messages: {
	noRecentResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentFullError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchFullError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchNoResults: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchIssueError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentPartialError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchPartialError: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issues: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projects: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	boards: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	filters: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	plans: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	recentFullErrorIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchNoResultsIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchIssueErrorIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	issuesIssueTermRefresh: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	projectsGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	searchNoResultsIssueTermRefreshGalaxia: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	noRecentResults: {
		id: 'command-palette-quick-search.common.error.no-recent-results',
		defaultMessage: 'Things in Jira that you’ve recently viewed will appear here.',
		description:
			'For recent - Message that displays when there are no recent items (no issues, projects, etc)',
	},
	recentFullError: {
		id: 'command-palette-quick-search.common.error.recent-full-error',
		defaultMessage:
			'We’re having trouble loading recently viewed issues. Try again in a few moments.',
		description: 'For recent - Error message if full api call fails',
	},
	searchFullError: {
		id: 'command-palette-quick-search.common.error.search-full-error',
		defaultMessage: 'We’re not sure what went wrong. Try again in a few moments.',
		description: 'While searching - Error message if full api call fails',
	},
	searchNoResults: {
		id: 'command-palette-quick-search.common.error.search-no-results',
		defaultMessage: 'No issue, project, board, plan, or filter matches your search',
		description:
			'While searching - Message that displays when there are no results for the search term',
	},
	searchIssueError: {
		id: 'command-palette-quick-search.common.error.search-issue-error',
		defaultMessage: 'We’re having trouble searching issues. You can try again in a few moments.',
		description: 'While searching - Message that shows when only issue search fails',
	},
	recentPartialError: {
		id: 'command-palette-quick-search.common.error.recent-partial-error',
		defaultMessage:
			'We are having trouble loading {errorList} from your recently viewed items. Try again in a few moments.',
		description:
			'While searching - Message that shows when only some object search api error call happens.',
	},
	searchPartialError: {
		id: 'command-palette-quick-search.common.error.search-partial-error',
		defaultMessage: 'We are having trouble searching {errorList}. Try again in a few moments.',
		description:
			'While searching - Message that shows when only some object search api error call happens.',
	},
	issues: {
		id: 'command-palette-quick-search.common.error.issues',
		defaultMessage: 'issues',
		description: 'Localised text for issues',
	},
	projects: {
		id: 'command-palette-quick-search.common.error.projects',
		defaultMessage: 'projects',
		description: 'Localised text for projects',
	},
	boards: {
		id: 'command-palette-quick-search.common.error.boards',
		defaultMessage: 'boards',
		description: 'Localised text for boards',
	},
	filters: {
		id: 'command-palette-quick-search.common.error.filters',
		defaultMessage: 'filters',
		description: 'Localised text for filters',
	},
	plans: {
		id: 'command-palette-quick-search.common.error.plans',
		defaultMessage: 'plans',
		description: 'Localised text for plans',
	},
	recentFullErrorIssueTermRefresh: {
		id: 'command-palette-quick-search.common.error.recent-full-error-issue-term-refresh',
		defaultMessage:
			'We’re having trouble loading recently viewed work items. Try again in a few moments.',
		description: 'For recent - Error message if full api call fails',
	},
	searchNoResultsIssueTermRefresh: {
		id: 'command-palette-quick-search.common.error.search-no-results-issue-term-refresh',
		defaultMessage: 'No work item, project, board, plan, or filter matches your search',
		description:
			'While searching - Message that displays when there are no results for the search term',
	},
	searchIssueErrorIssueTermRefresh: {
		id: 'command-palette-quick-search.common.error.search-issue-error-issue-term-refresh',
		defaultMessage:
			'We’re having trouble searching for work items. You can try again in a few moments.',
		description: 'While searching - Message that shows when only issue search fails',
	},
	issuesIssueTermRefresh: {
		id: 'command-palette-quick-search.common.error.issues-issue-term-refresh',
		defaultMessage: 'work items',
		description: 'Localised text for issues',
	},
	projectsGalaxia: {
		id: 'command-palette-quick-search.common.error.projects-galaxia',
		defaultMessage: 'spaces',
		description: 'Localised text for projects',
	},
	searchNoResultsIssueTermRefreshGalaxia: {
		id: 'command-palette-quick-search.common.error.search-no-results-issue-term-refresh-galaxia',
		defaultMessage: 'No work item, space, board, plan, or filter matches your search',
		description:
			'While searching - Message that displays when there are no results for the search term',
	},
});
